import { Outlet } from 'react-router';

import { ReservationProvider } from '../../hooks/reservation/context.tsx';
import { STANDARD_RESERVATION } from '../../hooks/reservation/standard.ts';

export default function BookingLayout() {
  return (
    <ReservationProvider config={STANDARD_RESERVATION}>
      <Outlet />
    </ReservationProvider>
  );
}
